const style1 = {
    backgroundColor: "#fff",
    display: "inline-block",
    fontFamily:"Roboto,sans-serif",
    color: "#a7a7a7",
    fontSize: "11px",
    width:" 100%",
    maxWidth:"376px"
}
const style2 = {
    padding:"0",
    margin: "0",
    textAlign: "left"
}
const style3 = {
    color:"#a7a7a7",
    textDecoration: "none",
    fontWeight: "normal",
    border: "none",
    display: "inline-block"
}
const style4 = {
    overflow: "hidden",
    position:"relative",
    height:"0",
    padding:"121.276596% 0 0 0",
    width:"100%"
}
const style5 = {
    display:"inline-block",
    position:"absolute",
    top:"0",
    left:"0",
    width:"100%",
    height:"100%",
    margin:"0"
}
function LockeJohnEmbed(){
    return (
        <>
        <div className="getty embed image" style={style1}><div style={style2}><a href="http://www.gettyimages.com/detail/175261533" target="_blank" rel="noreferrer" style={style3}>Embed from Getty Images</a></div><div style={style4}><iframe src="//embed.gettyimages.com/embed/175261533?et=qG4n7hCzQeJ_2vDguu9waQ&tld=com&sig=YWemXepz5Z3besrQalUtFnotJaMG6kU59b30DCUvTxQ=&caption=true&ver=1" title="John Locke" scrolling="no" frameBorder="0" width="376" height="456" style={style5}></iframe></div></div>
        </>
    );
};
export default LockeJohnEmbed;